import { NgModule } from '@angular/core';
import { AccountAlertComponent } from './account-alert.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../appMaterial/app-material.module';

@NgModule({
  imports: [CommonModule, RouterModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), AppMaterialModule],
  declarations: [AccountAlertComponent],
  exports: [AccountAlertComponent]
})
export class AccountAlertModule {}
